
import Vue from "vue";
import {
  requiredRule,
  maxLengthRule,
  minLengthRule,
} from "@/services/helpers/validation-rules";

export default Vue.extend({
  name: "Create",

  data: () => ({
    model: {} as any,
    errorMessages: {} as any,
  }),

  computed: {
    computedRules(): object {
      return {
        min: minLengthRule.bind(this),
        max: maxLengthRule.bind(this),
        required: requiredRule.bind(this),
      };
    },
  },

  methods: {
    async submit(): Promise<void> {
      try {
        if ((this.$refs.form as any).validate()) {
          await this.$API.universities().create(this.model);
          await this.$router.push("/universities");
          await this.$store.dispatch(
            "alert/showSuccess",
            this.$t("global-alert.successful_create")
          );
        }
      } catch (e) {
        if (e.hasOwnProperty("errors")) {
          this.errorMessages = e.errors;
          setTimeout(() => {
            this.errorMessages = {};
          }, 2000);
        }
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
  },
});
